import { twMerge } from "tailwind-merge";
import { Copy, Check } from "lucide-react";
import {
  ClipboardCopyButtonBase,
  type ClipboardCopyButtonBaseProps,
  type CopyType,
} from "@core/ui";
import { Button } from "@themes/pollinator/ui/Button";

export type { CopyType };

export type Props = Omit<ClipboardCopyButtonBaseProps, "renderButton"> & {
  /** Button label */
  label?: string;
};

/**
 * Styled clipboard copy button component wrapping ClipboardCopyButtonBase.
 * Shows a copy/check icon and changes text to "Copied!" after copying.
 */
export function ClipboardCopyButton({
  onCopy,
  label = "Copy",
  className,
  textToCopy = "",
  type = "plain",
  sectionName,
  "data-testid": testId = "clipboard-copy-button",
  ...props
}: Props) {
  return (
    <ClipboardCopyButtonBase
      onCopy={onCopy}
      textToCopy={textToCopy}
      type={type}
      sectionName={sectionName}
      data-testid={`${testId}-wrapper`}
      renderButton={({ onClick, copied }) => (
        <Button
          variant="secondary"
          onClick={onClick}
          iconComponent={copied ? Check : Copy}
          className={twMerge(
            "flex-shrink-0 flex-grow-0 whitespace-nowrap",
            className
          )}
          data-testid={testId}
        >
          {copied ? "Copied!" : label}
        </Button>
      )}
      {...props}
    />
  );
}

export default ClipboardCopyButton;

